import axios from 'axios';

const headers = {
    "Content-Type": "multipart/form-data"
}

export const getGeneral = async (last) => {
    if (last === null) {
        const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/generals/infinite`);
        return data;
    } else {
        const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/generals/infinite/?general_object_id=${last}`);
        return data
    }
}

export const getGeneralById = async (id) => {

    const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/generals/getpost/${id}`);
    return data;
}

export const postGeneral = async (general) => {
    const { data } = await axios.post(`${process.env.REACT_APP_AWS_URL}/api/generals/parseandroid`, general, { headers });
    return data;
}

export const putGeneral = async (id, general) => {
    const { data } = await axios.put(`${process.env.REACT_APP_AWS_URL}/api/generals/survey/${id}`, general);
    return data;
}

export const randomGeneral = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/generals/random`);
    return data;
}

